import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { Locales as LocalesGenerator } from "@core/locales";
import ErrorMessages from "./ErrorMessages.json";
var req = {
    ErrorMessages: ErrorMessages
};
var translations = {};
Object.keys(req).forEach(function(key) {
    var parts = key.split("/");
    var roots = parts.splice(0, parts.length - 2);
    var map = translations;
    roots.forEach(function(root) {
        if (!map[root]) {
            map = _object_spread_props(_object_spread({}, map), _define_property({}, root, {}));
        }
        map = map[root];
    });
    translations = _object_spread({}, map, req[key]);
});
var enDictionary = {
    locale: "en",
    translations: translations
};
export var Locales = new LocalesGenerator({
    dictionaries: [
        enDictionary
    ],
    defaultLocale: "en"
});

//# sourceMappingURL=Locales.js.map